import { BelegungsIntervall } from '@/domain/dienstplan/shared/types/Belegung';

export function getIntervalByMousePosition(
  intervall: BelegungsIntervall[],
  position: { x: number; y: number },
): BelegungsIntervall | undefined {
  for (let index = 0; index < intervall.length; index++) {
    const element = intervall[index];
    if (
      element.startX <= position.x &&
      position.x <= element.startX + element.width
    ) {
      return element;
    }
  }
  return undefined;
}
